import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CONSTANTS } from 'src/constants';
import { StorageManager } from 'src/app/common/utils/storage';
import { IAuthData } from './auth.interface';
import { AlertController } from '@ionic/angular';
import { LoaderService } from "../loader.service";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private authURL: string;
  private authData: IAuthData;
  private cacheLocation = 'localStorage';
  private storage = new StorageManager();
  activateService = !CONSTANTS.apiConfig.activateAPI;

  constructor(
    private http: HttpClient,
    private alertController: AlertController,
    private loaderService: LoaderService
  ) {
    this.initService();
  }

  initService() {
    if (!this.activateService) {
      console.log('Auth Service disabled!');
      return;
    }
    console.log('Auth Service starting...');

    this.setupAuthIfRedirected();
    let authData = this.getAuthData();

    if (authData) {
      let interval = setInterval(async () => {
        // console.log('cheking');
        if (!this.getAuthData()) {
          console.error('Auth token expired!!!');
          clearInterval(interval);
          this.alertTokenExpired();
        }
      }, 3000);
    } else {
      this.alertTokenExpired();
    }

    console.log('Auth Service started.');
  }

  async alertTokenExpired() {
    const alert = await this.alertController.create({
      header: 'Warning!',
      message: 'You need to authenticate your session by using your MS account!',
      buttons: ['OK']
    });
    alert.onWillDismiss().then(async () => {
      this.authenticate();

      await this.loaderService.withLoading('Go to Microsoft Auth Page', async () => {
      });
    });
    alert.present();
  }

  setCacheLocation(option: 'localStorage' | 'sessionStorage') {
    this.cacheLocation = option;
  }

  private get authUrl(): string {
    if (!CONSTANTS.authConfig.authUrl || CONSTANTS.authConfig.authUrl === '') {
      throw new Error('authUrl should be defined in CONSTANTS!');
    }

    let authURL = CONSTANTS.authConfig.authUrl + '?';

    Object.entries(CONSTANTS.authConfig.parameters).forEach(value => {
      authURL += '&' + value[0] + '=' + value[1];
    });

    return authURL;
  }

  /**
   * Checks if the current windows is redirected from Microsoft OAuth Page. If so, saves the token coming from MS.
   */
  private setupAuthIfRedirected() {
    if (window.location.hash.includes('#access_token')) {
      let hash = window.location.hash.substring(1); // string after the # char in the url.
      let parameterStrArr = hash.split('&'); // split the querys in the url
      let parameters: IAuthData = {};

      // split the paramenters from their data, and put them in array
      parameterStrArr.forEach(str => {
        let param = str.split('=');
        parameters[param[0]] = param[1];
      });
      console.log('Authentication parameters received.', parameters);
      window.location.hash = ''; // Remove hash string from the url
      this.storage.setLocalObject('authData', parameters); // save the auth data
      this.authData = parameters;
    }
  }

  private getAuthData(): IAuthData {
    let localAuthData = this.storage.getCommonObject('authData');
    let authData = localAuthData?.data;

    if (authData && new Date().getTime() > +authData.expires_in * 1000 + localAuthData.lastModify) {
      this.storage.removeCommonObject('authData');
      this.storage.removeCommonObject('userData');

      console.error('getAuthData Error: Auth token expired!');
      return undefined;
    }
    return authData;
  }

  public isAuthenticated(): boolean {
    if (!this.activateService) {
      return true;
    }
    return !!this.getAuthData();
  }

  public authenticate() {
    window.location.href = this.authUrl;
  }
}

//test
